import api from './api';

/**
 * Service for On-Demand Healthcare storage unit management
 */
class OnDemandStorageUnitService {
  static async getStorageUnits({ search, isActive, isPrimary } = {}) {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (isActive !== undefined) params.append('isActive', isActive);
    if (isPrimary !== undefined) params.append('isPrimary', isPrimary);
    
    const query = params.toString();
    return api.get(`/ondemand/storage-units${query ? `?${query}` : ''}`);
  }

  static async getStorageUnit(id) {
    return api.get(`/ondemand/storage-units/${id}`);
  }

  static async createStorageUnit(data) {
    return api.post('/ondemand/storage-units', data);
  }

  static async updateStorageUnit(id, data) {
    return api.put(`/ondemand/storage-units/${id}`, data);
  }

  static async deleteStorageUnit(id) {
    return api.delete(`/ondemand/storage-units/${id}`);
  }
}

export default OnDemandStorageUnitService;
